import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SvcPostPrivate } from '../services/userService.js';
import { toast } from 'react-toastify';

function HealthLogPage() {
  const navigate = useNavigate();
  const [selectedFeelings, setSelectedFeelings] = useState([]);
  const [isFine, setIsFine] = useState(false);
  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const feelings = [
    { id: 'tired', label: 'Tired', icon: 'airline_seat_individual_suite', key: 'fatigue' },
    { id: 'feverish', label: 'Feverish', icon: 'device_thermostat', key: 'fever' },
    { id: 'dizzy', label: 'Dizzy', icon: 'sync', key: 'dizziness' },
    { id: 'bloated', label: 'Bloated', icon: 'sentiment_stressed', key: 'stomach' },
    { id: 'acidity', label: 'Acidity', icon: 'local_fire_department', key: 'acidity' },
    { id: 'headache', label: 'Headache', icon: 'neurology', key: 'headache' }
  ];

  const toggleFeeling = (feelingId) => {
    if (selectedFeelings.includes(feelingId)) {
      setSelectedFeelings(selectedFeelings.filter((f) => f !== feelingId));
    } else {
      setSelectedFeelings([...selectedFeelings, feelingId]);
      setIsFine(false);
    }
  };

  const toggleFine = () => {
    setIsFine(!isFine);
    if (!isFine) {
      setSelectedFeelings([]);
      setDescription('');
    }
  };

  const handleSave = async () => {
    if (selectedFeelings.length === 0 && !isFine && !description.trim()) {
      toast.error('Please select how you feel or add a description.');
      return;
    }

    setIsLoading(true);

    let symptomsArray = [];

    if (isFine) {
      symptomsArray.push('fine');
    } else {
      selectedFeelings.forEach((feelingId) => {
        const feeling = feelings.find((f) => f.id === feelingId);
        if (feeling && feeling.key) symptomsArray.push(feeling.key);
      });
    }

    const payload = {
      symptoms: symptomsArray.join(','),
      symptoms_summary: description.trim() || ''
    };

    try {
      const res = await SvcPostPrivate('/report/add-symptoms', payload);

      if (res.data?.status) {
        toast.success('Health log saved successfully!');

        // 🔥 Navigate to scan page after 1 second
        setTimeout(() => {
          navigate('/scan', { replace: true });
        }, 800);
      } else {
        toast.error(res.data?.message || 'Failed to save');
      }
    } catch (error) {
      toast.error('Something went wrong!');
    } finally {
      setIsLoading(false);
    }
  };

  const getCurrentDate = () => {
    const options = { weekday: 'long', day: 'numeric', month: 'long' };
    return new Date().toLocaleDateString('en-US', options);
  };

  return (
    <section className="health-log-section">
      <div className="health-log-card">
        <header className="health-log-header">
          <div className="back-btn" onClick={() => navigate(-1)}>
            <span className="material-symbols-outlined">arrow_back</span>
          </div>
          <h1 className="header-text">Health Log</h1>
          <div className="header-spacer"></div>
        </header>

        <main className="health-log-main">
          <p className="log-date">{getCurrentDate()}</p>
          <h2 className="log-title">How are you feeling today?</h2>

          <div className="feelings-grid">
            {feelings.map((feeling) => (
              <button
                key={feeling.id}
                className={`feeling-btn ${
                  selectedFeelings.includes(feeling.id) ? 'active' : ''
                } ${isFine ? 'disabled' : ''}`}
                onClick={() => toggleFeeling(feeling.id)}
                disabled={isFine}
              >
                <span className="material-symbols-outlined">{feeling.icon}</span>
                {feeling.label}
              </button>
            ))}
          </div>

          <div className="add-more-title">Want to add more?</div>

          <div className="textarea-wrapper">
            <textarea
              className="log-textarea"
              placeholder="Describe how you feel..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              disabled={isFine}
            />
          </div>

          <button
            className={`fine-btn ${isFine ? 'active' : ''}`}
            onClick={toggleFine}
            disabled={isLoading}
          >
            I'm Fine
          </button>

          <div className="spacer"></div>

          <button
            className="save-btn"
            onClick={handleSave}
            disabled={
              isLoading ||
              (selectedFeelings.length === 0 && !isFine && !description.trim())
            }
          >
            {isLoading ? 'Saving...' : 'Save Entry'}
          </button>
        </main>
      </div>
    </section>
  );
}

export default HealthLogPage;
